/*
 * @Author: LiuMeiYu
 * @Date: 2022-12-26 10:25:43
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-02-11 10:34:51
 * @FilePath: \CardSwap\src\router\index.js
 * @Description: *
 * *
 * Copyright (c) 2022 by yihua, All Rights Reserved.
 */
import { nextTick } from 'vue';
import {
  createRouter,
  createWebHistory
} from 'vue-router'
import layoutView from "../layout/layoutView.vue"

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/404',
    name: "404",
    component: () => import('@/views/404.vue'),
    meta: {
      title: "404",
      requireAuth: false
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home/homeView.vue'),
    meta: {
      title: "CardSwap-Home",
      requireAuth: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/loginView.vue'),
    meta: {
      title: "CardSwap-Login",
      requireAuth: false
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register/registerView.vue'),
    meta: {
      title: "CardSwap-Register",
      requireAuth: false
    }
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: () => import('@/views/forgotPassword/forgotPasswordView.vue'),
    meta: {
      title: "CardSwap-forgot Password",
      requireAuth: false
    }
  },
  {
    component: layoutView,
    redirect: "/home",
    meta: {
      title: "CardSwap-Home",
      requireAuth: false
    },
    children: [
      {
        path: '/chat',
        name: 'Chat',
        component: () => import('@/views/chat/chatView.vue'),
        meta: {
          title: "CardSwap-Chat",
          requireAuth: false
        }
      },
      {
        path: '/orderList',
        name: 'OrderList',
        component: () => import('@/views/order/orderListView.vue'),
        meta: {
          title: "CardSwap-OrderList",
          requireAuth: true
        }
      },
      {
        path: '/orderDetails',
        name: 'OrderDetails',
        component: () => import('@/views/order/orderDetailsView.vue'),
        meta: {
          title: "CardSwap-OrderDetails",
          requireAuth: true
        }
      },
      {
        path: '/demandList',
        name: 'DemandList',
        component: () => import('@/views/demand/demandListView.vue'),
        meta: {
          title: "CardSwap-DemandList",
          requireAuth: false
        }
      },
      {
        path: '/createDemand',
        name: 'CreateDemand',
        component: () => import('@/views/demand/createDemandView.vue'),
        meta: {
          title: "CardSwap-CreateDemand",
          requireAuth: true
        }
      },
      {
        path: '/account',
        name: 'Account',
        component: () => import('@/views/account/accountView.vue'),
        meta: {
          title: "CardSwap-Account",
          requireAuth: true
        }
      },
      {
        path: '/set',
        name: 'Set',
        component: () => import('@/views/set/setView.vue'),
        meta: {
          title: "CardSwap-Set",
          requireAuth: true
        }
      },
      {
        path: '/wallet',
        name: 'Wallet',
        component: () => import('@/views/wallet/walletView.vue'),
        meta: {
          title: "CardSwap-Wallet",
          requireAuth: true
        }
      },
    ]
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/404'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// 全局路由导航拦截
router.beforeEach((to) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "CardSwap";
  }
  // 是否是登录页
  if (to.path !== "/login") {
    // 不是登录页 判断是否需要登录 && sessionStorage.getItem("token")
    if (to.meta.requireAuth) { // false为不需要 true为需要
      // 再判断是否已经登录
      if (localStorage.getItem("token")) {
        return true;
      } else {
        localStorage.removeItem("country_id");
        localStorage.removeItem("currency_name");
        localStorage.removeItem("userId");
        localStorage.removeItem("userInfo");
        nextTick(() => {
          router.push({ path: "/login", query: { redirect: to.fullPath } });
          return true;
        });
      }
    } else { // 不是登录页 不需要登录
      return true;
    }
  } else {
    return true;
  }
});

export default router